<template>
  <section class="message-card-cms-parts">
    <div class="_message-card-container">
      <div class="_message-card-item">
        <div class="_image-box">
          <img v-if="!isMobile" class="_img" :src="ConvertImagePath(backgroundImg, 0.8)" />
          <img v-else class="_img" :src="ConvertImagePath(spBackgroundImg, 0.8)" />
        </div>
        <div class="_text-box">
          <div class="_icon-image">
            <AtomsConsumerTentialLogo variant="text" :width="140" :height="40" />
          </div>
          <h3
            class="_title"
            :class="[fontSize, fontWeight, { 'page-parts-pc': spTitle ? true : false }]"
            v-html="sanitizeHtmlContent(title)"
          ></h3>
          <h3
            v-if="spTitle"
            class="_title page-parts-sp"
            :class="[fontSize, fontWeight]"
            v-html="sanitizeHtmlContent(spTitle)"
          ></h3>
          <p class="_description page-parts-pc" :class="[descFontSize]" v-html="sanitizeHtmlContent(description)"></p>
          <p
            v-if="spDescription"
            class="_description page-parts-sp"
            :class="[descFontSize]"
            v-html="sanitizeHtmlContent(spDescription)"
          ></p>
          <div class="_link-button-box">
            <AtomLink :url="linkUrl" class="_link-button">
              {{ linkText }}
              <span class="_arrow"></span>
            </AtomLink>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { sanitizeHtmlContent } from "@tential/ec-gql-schema/utils/functions/sanitize"
import { ConvertImagePath } from "../../utils/functions/img"

type Props = {
  title?: string
  spTitle?: string
  description?: string
  spDescription?: string
  fontSize?: string[]
  descFontSize?: string[]
  fontWeight?: string
  linkUrl?: string
  linkText?: string
  backgroundImg?: string
  spBackgroundImg?: string
}

withDefaults(defineProps<Props>(), {
  spTitle: "",
  spDescription: "",
  fontSize: () => [],
  descFontSize: () => [],
  fontWeight: "",
  linkText: "Next",
  title: "",
  description: "",
  linkUrl: "",
  backgroundImg: "",
  spBackgroundImg: "",
})

// SP判定
const isMobile = useState<boolean>(() => false)
// isMobile.value = context.root.$device.isMobile
// useDevice
</script>
